// eslint-disable-next-line import/prefer-default-export
export const feedSelector = (state, props) => props.match.params.feed;



// WEBPACK FOOTER //
// /src/js/common/transitionRouter/transitionRouter.selectors.js